const EncodeDecode = {
    setValue: function (str) {
        const rand = Math.random().toString(36).slice(2, 12);
        return window.btoa(rand + '###' + str + '###' + rand);
    },
    getValue: function (str) {
        try {
            const decoded = window.atob(str);
            const parts = decoded.split('###');
            parts.shift();
            parts.pop();
            return parts;
        } catch (e) {
            return [];
        }
    }
};

export default EncodeDecode;
